export const PORTFOLIO_INFO_CONFIG = {
    name            : 'Info',
    menuName        : 'Info',
    icon            : 'i5-dashboard',
    image           : 'events-summary',
    url             : 'info',
    stringId        : 'summary',
    description     : 'Portfolio info'
}
